import { ArticleRounded } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import dayjs from "dayjs"
import { numberFormat } from "utils"

export const columns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "LicNm",
    headerName: "ทะเบียน",
    width: 100,
  },
  {
    field: "DrvNm",
    headerName: "พนักงานขับรถ",
    width: 165,
  },
  {
    field: "NumJo",
    headerName: "จำนวนเที่ยว",
    width: 90,
    align: "center"
  },
  {
    field: "DrvFixCost",
    headerName: "เงินเดือน พขร.",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "TripAmnt",
    headerName: "ค่าเที่ยว พขร",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "CostAmnt",
    headerName: "ต้นทุนอื่นๆ",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "OprTotal",
    headerName: "รวมต้นทุน",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvTransAmnt",
    headerName: "รายได้ค่าขนส่ง",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvOthOwnRcptAmnt",
    headerName: "ใบเสร็จบริษัทอื่น",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvOwnRcptAmnt",
    headerName: "รวมใบเสร็จบริษัท",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvCusRcptAmnt",
    headerName: "รายได้ใบเสร็จลูกค้า",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvTotal",
    headerName: "รวมรายได้",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "Profit",
    headerName: "กำไรเบื้องต้น",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "TripAmntPerJo",
    headerName: "ค่าเที่ยว/เที่ยว",
    width: 130,
    align: 'right',
    valueGetter: ({ row }) => row.NumJo === 0 ? "" : row.TripAmnt / +row.NumJo,
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
]

export const detailColumns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "LicNm",
    headerName: "ทะเบียน",
    width: 100,
  },
  {
    field: "DrvNm",
    headerName: "พนักงานขับรถ",
    width: 150,
  },
  {
    field: "AptTm",
    headerName: "วันที่นัด",
    width: 110,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "ContNo",
    headerName: "หมายเลขตู้",
    width: 120,
  },
  {
    field: "Loc",
    headerName: "สถานที่",
    valueGetter: ({id, row}) =>id===0?"":  `${row.TakePlc} - ${row.Loc} - ${row.RtnPlc}`,
    flex: 1,
    minWidth: 200,
  },
  {
    field: "DrvFixCost",
    headerName: "เงินเดือน พขร.",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "TripAmnt",
    headerName: "ค่าเที่ยว พขร",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "CostAmnt",
    headerName: "ต้นทุนอื่นๆ",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "OprTotal",
    headerName: "รวมต้นทุน",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvTransAmnt",
    headerName: "รายได้ค่าขนส่ง",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvOthOwnRcptAmnt",
    headerName: "ใบเสร็จบริษัทอื่น",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvOwnRcptAmnt",
    headerName: "รวมใบเสร็จบริษัท",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvCusRcptAmnt",
    headerName: "รายได้ใบเสร็จลูกค้า",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvTotal",
    headerName: "รวมรายได้",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "Profit",
    headerName: "กำไรเบื้องต้น",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
]